import { Page } from '@/components/layout';
import { EVENTS_BY_SLUG, formatDateRangeLong } from '@/features/events';
import { FaqSection } from '@/pages/shared/BriefBlocks';
import { CtaBand, PorQueIr, ReservaCta } from '@/pages/shared/ConversionBlocks';
import { BeneficiosFunes } from './sections/BeneficiosFunes';
import { HeroFunes } from './sections/HeroFunes';
import { ProgramaFunes } from './sections/ProgramaFunes';

/* =============================================================================
 * /funes · Convivencia «Encuentro con el Ser» · 2-3 febrero 2027
 * -----------------------------------------------------------------------------
 * EL SEXTO DESTINO, y el PRIMERO de la gira por fecha. Entró el 23-sep-2026 con
 * un flyer del cliente por WhatsApp: lugar, fechas, teléfono y un mensaje de
 * WhatsApp prefijado. Nada más. No hay mockup, no hay horarios y NO HAY VENTA
 * DE ENTRADAS — «no hace falta entradas, es simple».
 *
 * POR QUÉ ESTA PÁGINA ES DE BLOQUES COMPARTIDOS Y NO A MEDIDA COMO LAS OTRAS
 * CINCO. Las cinco páginas de ciudad calcan un póster aprobado, pieza a pieza.
 * Aquí no hay póster que calcar: inventarle una escena propia sería inventarle
 * al cliente un diseño que no ha visto ni pedido. Los bloques compartidos
 * (`ReservaCta`, `PorQueIr`, `CtaBand`, `FaqSection`) ya se alimentan del dato
 * tipado, así que la página sale coherente con la gira sin una sola línea de
 * copy tecleada aquí.
 *
 * El CTA no lleva a una tienda: lleva a WhatsApp con el mensaje que el cliente
 * escribió, por el estado de venta `whatsapp` (ver `event.links.ts`).
 *
 * SIN `CancunUpsell`, Y NO POR OLVIDO. Ese bloque rotula «el recorrido de la
 * gira termina aquí. Después de {ciudad}, el último escalón», que es cierto en
 * las cinco ciudades para las que se escribió y FALSO en Funes: Funes es la
 * PRIMERA parada, tres días antes de Buenos Aires y con toda la gira por
 * delante. Antes que contarle al visitante una secuencia que no existe, este
 * escalón del embudo se deja fuera hasta que haya copy propio.
 * ========================================================================== */
export function FunesPage() {
  const event = EVENTS_BY_SLUG.funes;

  return (
    <Page
      documentTitle={`${event.city} · ${event.title}`}
      description={`${event.title}. ${event.city}, ${event.country} · ${formatDateRangeLong(event)}. ${event.tagline}`}
      tone={event.heroTone}
    >
      <HeroFunes event={event} />
      <ReservaCta event={event} />
      <BeneficiosFunes event={event} />
      <ProgramaFunes event={event} />
      <PorQueIr event={event} background="alt" />
      <CtaBand event={event} texto={`${event.city}, ${event.country} · ${formatDateRangeLong(event)}`} />
      <FaqSection items={event.faq} grupo="faq-funes" />
    </Page>
  );
}
